import axios from 'axios';
import store from '../store';

export default function setup() {
  // Request interceptor
  axios.interceptors.request.use(
    (request) => {
      if (request.url && request.url.includes('/kube/')) {
        if (store.state.user.dryMode) {
          request.headers.dryMode = '1';
        }
      }
      return request;
    },
    (error) => {
      console.log(error);
      return Promise.reject(error);
    }
  );

  // Response interceptor to handle 401 errors
  axios.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      if (error.response && error.response.status === 401) {
        console.log('401 Unauthorized - Auto logging out user');
        // Auto logout the user when receiving 401, even if token is still valid
        store.dispatch('logout').then(() => {
          // Redirect to login page
          if (window.location.pathname !== '/login') {
            window.location.href = '/login';
          }
        });
      }
      return Promise.reject(error);
    }
  );
}
